<template>
  <div id="reviewsTable">
    <div v-if="!desktop">
      <v-carousel hide-delimiters
        height="750px">
        <v-carousel-item
          dark
          v-for="(review,i) in reviews"
          :key="i"
          :src="review"
          reverse-transition="fade-transition"
          transition="fade-transition"
          delimiter-icon="mdi-circle-medium"
        >
          <v-card

          class="mx-auto"
          max-width="400"
          >
            <v-card-title style="background-color: var(--accentColorShaded); width: 100%;" class="title">{{review.name}}, <span style="position: relative; right: -4px;;">{{reviewContent[review.id].date}}</span></v-card-title>

            <v-img
              :src="review.img"
            ></v-img>
            <v-card-subtitle style="background-color: var(--accentColorShaded);" class="description" color="var(--accentColorShaded)">
              <p>
              <span v-if="product == 'table' || product == 'bench'">{{getText.dimensions}}{{review.length}}cm x {{review.width}}cm x {{review.height}}cm <br /><br /></span>
              <!-- {{review.text}} -->
              {{reviewContent[review.id].text}}

              </p>
            </v-card-subtitle>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </div>

    <div v-if="desktop">
      <v-carousel hide-delimiters
        height="750px">
        <v-carousel-item
          dark
          v-for="(review,j) in reviews"
          :key="j"
          :src="review"
          reverse-transition="fade-transition"
          transition="fade-transition"
          delimiter-icon="mdi-circle-medium"
        >
          <div id="leftRightElementLocal">
            <div id="left">
              <h1>{{review.name}}, {{reviewContent[review.id].date}}</h1>
              <h2>{{getText.dimensions}}{{review.length}}cm x {{review.width}}cm x {{review.height}}cm</h2>
              <p style="margin-top: 30px;">{{reviewContent[review.id].text}}</p>
            </div>
            <div id="right">
              <v-img
                :src="review.img"
              ></v-img>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReviewsTable',
  components: {
    // HelloWorld
  },
  props: ['product', 'desktop'],
  data() {
    return{
      reviews: [],
      reviewContent: {},
      text: "text"
    }
   },
   computed: {
     getText(){
       return this.$store.getters.getText.configurator.reviews
     },
     // reviews(){
     //   return this.$store.getters.getReviews.tables
     // },
   },
   methods: {
     getReviewText(name){
       var value = this.reviewContent[name]
       console.log(value.text)
       return value.text
     }
   },
   mounted () {
     switch (this.product){
       case 'table':
        this.reviews = this.$store.getters.getReviews.table
        this.reviewContent = this.$store.getters.getText.reviews.table
       break;
       case 'bench':
        this.reviews = this.$store.getters.getReviews.bench
        this.reviewContent = this.$store.getters.getText.reviews.bench
       break;
       case 'stool':
        this.reviews = this.$store.getters.getReviews.stool
        this.reviewContent = this.$store.getters.getText.reviews.stool
       break;
       default:
       break;
     }
   },
}
</script>

<style scoped>
#leftRightElementLocal{
  width:100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 750px;
}
#left{
  background-color: var(--accentColorShaded);
  padding: 25% 15%;
  color: var(--mainColor);
  text-align: left;
}
#right{

}
  .title{
    font-family: 'Mina' !important;
    color: var(--mainColor);
  }
  .description {
    font-family: 'PT Sans' !important;
    color: var(--mainColor) !important;
    padding-left: 17px;
    text-align: left;
  }
  #cartProductList{
    padding: 0 10px;
    margin: auto;
    width: 350px;
    position: relative;
  }
  .productListElement{
    margin: 5px 0;
    padding: 5px 0;
    width: 100%;
    display: grid;
    grid-template-columns: 160px 1fr 25px;
  }
  .theme--dark.v-sheet {
    background-color: white !important;
  }

</style>
